import { BORDER_COLORS, TEXT_COLORS as TC, TEXT_COLORS } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const TooltipContentWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const TooltipIconWrapper = styled.span`
    svg {
        margin-top: -10px;
    }
`;

export const TooltipContent = styled.div`
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_XL].fontWeight}
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight}
    ${FONT_FAMILY.poppins};
    color: ${TC.heading};
    padding: 12px;
`;

export const ModalTopSection = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    padding-top: 16px;
    align-items: center;
`;

export const ModalHeader = styled.div`
    color: ${TC.heading};
    ${DESKTOP_SIZES[SIZES.HEADING_SM].fontSize}
    ${DESKTOP_SIZES[SIZES.HEADING_MD].fontWeight};
    ${DESKTOP_SIZES[SIZES.HEADING_SM].lineHeight}
`;

export const ModalInfoText = styled.div`
    margin: 16px 0;
    color: ${TC.body};
    ${DESKTOP_SIZES[SIZES.BODY_MD].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_MD].fontWeight};
    ${DESKTOP_SIZES[SIZES.BODY_MD].lineHeight}
`;

export const ModalButtonsWrapper = styled.footer`
    display: flex;
    align-items: center;
    column-gap: 16px;
    margin-top: 32px;
    width: 100%;
    margin-bottom: 24px;

    button {
        flex: 1;
    }
`;

export const ModalFooterWrapper = styled.footer`
    display: flex;
    align-items: center;
    column-gap: 16px;
    width: 100%;

    button {
        flex: 1;
    }
`;

export const TooltipTitleWrapper = styled.div`
    color: ${TEXT_COLORS.heading};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_XS].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_XS].fontWeight};
`;

export const ItemText = styled.div`
    flex: 1;
    text-align: left;
`;

export const DescText = styled.span`
    color: ${TEXT_COLORS.body};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize};
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontWeight};
`;

export const SharedPageWrapper = styled.div<{
    $paddingBottom?: number;
    $shouldTakeAllAvailableSpace?: boolean;
}>`
    padding: 24px;
    display: flex;
    flex-direction: column;
    ${FONT_FAMILY.poppins};

    ${({ $shouldTakeAllAvailableSpace }) => $shouldTakeAllAvailableSpace && 'flex: 1;'}
    ${({ $paddingBottom }) => $paddingBottom !== undefined && `padding-bottom: ${$paddingBottom}px;`};

    div[role='tab'] {
        ${FONT_FAMILY.poppins};
    }

    div[role='tablist'] {
        width: fit-content;
    }
`;

export const MODAL_FORCED_STYLES = {
    mask: {
        background: BORDER_COLORS.blur,
        backdropFilter: 'blur(4px)',
    },
};
